import { useEffect } from 'react';

import { isEmbeddableSandboxRoute } from 'src/app/embeddableSandbox/isEmbeddableSandboxRoute';
import Config from 'src/lib/config';
import { useLDFlag } from 'src/lib/launchDarkly';
import { amplitudeClient } from 'src/lib/tracking';

const { studioUrl } = Config.settings;

const getAmplitudeDeviceId = async () => {
  await amplitudeClient.ready;
  return amplitudeClient.getDeviceId();
};

const syncViaIframe = (url: string) => {
  const iframe = document.createElement('iframe');
  iframe.src = url;
  iframe.style.display = 'none';
  iframe.style.border = 'none';
  iframe.style.height = '0';
  iframe.style.width = '0';
  document.body.appendChild(iframe);
};

const sendSyncSignal = () => {
  getAmplitudeDeviceId().then((deviceId) => {
    if (!deviceId) return;
    // Be nice and avoid hogging a socket for the first 10 seconds.
    setTimeout(() => {
      const url = `${studioUrl}/iframeIdentitySync?did=${deviceId}`;
      syncViaIframe(url);
    }, 10 /* seconds */ * 1000 /* milliseconds */);
  });
};

export const useSyncAmplitudeForEmbedded = () => {
  const trackEmbeddedUsers = useLDFlag('betelgeuse-amplitude-in-embedded');

  useEffect(() => {
    if (isEmbeddableSandboxRoute() && trackEmbeddedUsers) {
      sendSyncSignal();
    }
  }, [trackEmbeddedUsers]);
};
